<template>
  <div class="life-loader" v-if="show">
    <div class="sk-wave">
      <img class="turn-element" src="../../public/img/header/lifesycleloader.gif" alt="Loader"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: { show: null },
};
</script>

<style scoped>

  .life-loader {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color:  white;
    opacity: 0.7;
    z-index: 99999999;
  }
  .sk-wave {
    margin: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sk-rect {
    background: #fff;
    margin-right: 2px;
    box-shadow: 0 0 5px #565656;
  }

  .sk-wave img {
    width: 80px;
    height: 80px;
  }
</style>
